import './login.less'

import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {LoginForm} from './forms/login';
import {Button} from 'antd';
import {SignForm} from './forms/sign';
import {Link} from 'react-router-dom';
import SignStart from './sign-start';
import SignConfirmation from './sign-confirmation';

@inject('loginStore')
@observer
class Sign extends Component {

  render() {
    const {user} = this.props.loginStore;

    return (
      <div className="login-page">
        <div>
          {!user && <SignStart />}
          {user && user.user.status === 'registered' && <SignConfirmation/>}
        </div>
      </div>
    );
  }

}

export default Sign



// WEBPACK FOOTER //
// ./src/components/pages/auth/sign.js